import { action, makeObservable, observable } from "mobx"
import { Constraints } from "."

class Stream {

  constraints: Constraints = { audio: false, video: false }
  mediaStream: MediaStream | null = null
  pc: RTCPeerConnection

  constructor() {
    makeObservable(this, {
      constraints: observable,
      mediaStream: observable.ref,
      setConstraints: action,
      onTrack: action.bound
    })
    this.pc = new RTCPeerConnection()
    this.pc.addEventListener("track", this.onTrack)
  }

  // Методы для вещания
  async produce(tracks: MediaStreamTrack[], constraints: Partial<Constraints>) {
    
    this.setConstraints(constraints)
    let needStream = false
    for (let track of tracks) {
      needStream = needStream || this.addTrack(track)
    }
    this.applyConstraints()

    if (needStream) {
      const offer = await this.pc.createOffer()
      await this.pc.setLocalDescription(offer)
      return { offer, constraints: this.constraints }
    }
    return { constraints: this.constraints }
  }

  async consume(answer: any) {
    await this.pc.setRemoteDescription(answer)
  }

  // Методы для принятия потока
  async handleProduce(offer: any, constraints: Constraints) {
    this.setConstraints(constraints)
    if (offer) {
      await this.pc.setRemoteDescription(offer)
      const answer = await this.pc.createAnswer()
      await this.pc.setLocalDescription(answer)
      return answer
    }
    return null
  }

  // Общие методы
  setConstraints(constraints: Partial<Constraints>) {
    this.constraints = {
      ...this.constraints,
      ...constraints
    }
  }

  onTrack(e: RTCTrackEvent) {
    if (!e.streams[0]) return
    this.mediaStream = e.streams[0]
  }

  close() {
    if (this.pc.connectionState === "closed") {
      return false
    }
    this.pc.close()
    for (let sender of this.pc.getSenders()) {
      sender.track?.stop()
    }
    for (let receiver of this.pc.getReceivers()){
      receiver.track?.stop()
    }

    return true
  }

  // Вспомогательные методы
  private addTrack(track: MediaStreamTrack) {
    for (let sender of this.pc.getSenders()) {
      if (!sender.track || sender.track.kind !== track.kind) continue

      if (sender.track.readyState === "ended") {
        sender.replaceTrack(track)
      }
      return false
    }
    this.pc.addTrack(track)
    return true
  }

  private applyConstraints() {
    for (let sender of this.pc.getSenders()) {
      if (!sender.track || sender.track.readyState !== "live") continue
      if (this.constraints[sender.track.kind as "video" | "audio"] === false) {
        sender.track.stop()
      }
    }
  }
}

export default Stream